// Logos e Identidade Visual
import logo from './logos/logo.png'
import logoWhite from './logos/Logo - Branca.png'
import iconColorido from './logos/icon_colorido.png'
import iconAppAlunoAndroid from './logos/icon_app_aluno_android.png'
import iconAppAlunoDegrade from './logos/icon_app_aluno_com_degrade.png'
import iconAppEscola from './logos/icon_app_escola.png'
import clientePiloto from './logos/logomarca_cliente_piloto_agua_vida.jpeg'

// Imagens Gerais
import image from './general/image.png'

// Screenshots dos Apps
import mockupAluno from './apps/aluno/SwimmingPool Aluno/mockup_3_telas_com_moldura.png'
import homeAluno from './apps/aluno/SwimmingPool Aluno/prints iphone e android/tela_home.jpeg'
import trofeusAluno from './apps/aluno/SwimmingPool Aluno/prints iphone e android/tela_meus_trofeus.jpeg'
import avaliacoesAluno from './apps/aluno/SwimmingPool Aluno/prints iphone e android/tela_minhas_avaliacoes.jpeg'
import pagamentosAluno from './apps/aluno/SwimmingPool Aluno/prints iphone e android/tela_pagamentos_mensalidades_em_aberto.png'

import homeEscola from './apps/escola/SwimmingPool Escola/prints Iphone 16 pro max/tela_home_rsumo_geral.png'
import pagamentosEscola from './apps/escola/SwimmingPool Escola/prints Iphone 16 pro max/tela_pagamentos_indicadores_kpis.png'
import agendaEscola from './apps/escola/SwimmingPool Escola/prints Iphone 16 pro max/tela_agenda_semanal.png'
import turmasEscola from './apps/escola/SwimmingPool Escola/prints Iphone 16 pro max/tela_listagem-turmas.png'

import dashboardProfessor from './apps/professor/SwimmingPool Professor/tela_dashboard_inicial.jpeg'
import avaliacaoProfessor from './apps/professor/SwimmingPool Professor/tela_avaliacao_listagem_alunos.jpeg'
import avaliandoProfessor from './apps/professor/SwimmingPool Professor/tela_avaliando_aluno.jpeg'
import agendaProfessor from './apps/professor/SwimmingPool Professor/tela_minha_agenda.jpeg'

export const logos = {
  logo,
  logoWhite,
  iconColorido,
  iconAppAlunoAndroid,
  iconAppAlunoDegrade,
  iconAppEscola,
  clientePiloto
}

export const general = {
  image
}

export const appScreenshots = {
  aluno: {
    mockup: mockupAluno,
    home: homeAluno,
    trofeus: trofeusAluno,
    avaliacoes: avaliacoesAluno,
    pagamentos: pagamentosAluno
  },
  escola: {
    home: homeEscola,
    pagamentos: pagamentosEscola,
    agenda: agendaEscola,
    turmas: turmasEscola
  },
  professor: {
    dashboard: dashboardProfessor,
    avaliacao: avaliacaoProfessor,
    avaliando: avaliandoProfessor,
    agenda: agendaProfessor
  }
}

// Todas as imagens
export const images = {
  logos,
  general,
  appScreenshots
}

export default images
